import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ShareServiceService {

  user
  statecity = {
    "Johor": [
      "Johor Bahru",
      "Tebrau",
      "Pasir Gudang",
      "Bukit Indah",
      "Skudai",
      "Kluang",
      "Batu Pahat",
      "Muar",
      "Ulu Tiram",
      "Senai",
      "Segamat",
      "Kulai",
      "Kota Tinggi",
      "Pontian Kechil",
      "Tangkak",
      "Bukit Bakri",
      "Yong Peng",
      "Pekan Nenas",
      "Labis",
      "Mersing",
      "Simpang Renggam",
      "Parit Raja",
      "Kelapa Sawit",
      "Buloh Kasap",
      "Chaah"
    ],
    "Kedah": [
      "Sungai Petani",
      "Alor Setar",
      "Kulim",
      "Jitra / Kubang Pasu",
      "Baling",
      "Pendang",
      "Langkawi",
      "Yan",
      "Sik",
      "Kuala Nerang",
      "Pokok Sena",
      "Bandar Baharu"
    ],
    "Kelantan": [
      "Kota Bharu",
      "Pangkal Kalong",
      "Tanah Merah",
      "Peringat",
      "Wakaf Baru",
      "Kadok",
      "Pasir Mas",
      "Gua Musang",
      "Kuala Krai",
      "Tumpat"
    ],
    "Melaka": [
      "Bandaraya Melaka",
      "Bukit Baru",
      "Ayer Keroh",
      "Klebang",
      "Masjid Tanah",
      "Sungai Udang",
      "Batu Berendam",
      "Alor Gajah",
      "Bukit Rambai",
      "Ayer Molek",
      "Bemban",
      "Kuala Sungai Baru",
      "Pulau Sebang",
      "Jasin"
    ],
    "Negeri Sembilan": [
      "Seremban",
      "Port Dickson",
      "Nilai",
      "Bahau",
      "Tampin",
      "Kuala Pilah"
    ],
    "Pahang": [
      "Kuantan",
      "Temerloh",
      "Bentong",
      "Mentakab",
      "Raub",
      "Jerantut",
      "Pekan",
      "Kuala Lipis",
      "Bandar Jengka",
      "Bukit Tinggi"
    ],
    "Perak": [
      "Ipoh",
      "Taiping",
      "Sitiawan",
      "Simpang Empat",
      "Teluk Intan",
      "Batu Gajah",
      "Lumut",
      "Kampung Koh",
      "Kuala Kangsar",
      "Sungai Siput Utara",
      "Tapah",
      "Bidor",
      "Parit Buntar",
      "Ayer Tawar",
      "Bagan Serai",
      "Tanjung Malim",
      "Lawan Kuda Baharu",
      "Pantai Remis",
      "Kampar",
      "Batu Gajah"
    ],
    "Perlis": [
      "Kangar",
      "Arau",
      "Padang Besar",
      "Kuala Perlis"
    ],
    "Pulau Pinang": [
      "Bukit Mertajam",
      "Georgetown",
      "Sungai Ara",
      "Gelugor",
      "Ayer Itam",
      "Butterworth",
      "Perai",
      "Nibong Tebal",
      "Permatang Kucing",
      "Tanjung Tokong",
      "Kepala Batas",
      "Tanjung Bungah",
      "Juru",
      "Penang",
      "Simpang Ampat",
      "Penang Island",
      "Bayan Lepas",
      "Balik Pulau"
    ],
    "Sabah": [
      "Kota Kinabalu",
      "Sandakan",
      "Tawau",
      "Lahad Datu",
      "Keningau",
      "Putatan",
      "Donggongon",
      "Semporna",
      "Kudat",
      "Kunak",
      "Papar",
      "Ranau",
      "Beaufort",
      "Kinarut",
      "Kota Belud"
    ],
    "Sarawak": [
      "Kuching",
      "Miri",
      "Sibu",
      "Bintulu",
      "Limbang",
      "Sarikei",
      "Sri Aman",
      "Kapit",
      "Batu Delapan Bazaar",
      "Kota Samarahan"
    ],
    "Selangor": [
      "Kota Kemuning",
      "Denai Alam",
      "Batu Caves",
      "Putra Height",
      "Sungai Long",
      "Subang Jaya",
      "Klang",
      "Ampang",
      "Ampang Jaya",
      "Shah Alam",
      "Petaling Jaya",
      "Cheras",
      "Kajang",
      "Selayang Baru",
      "Rawang",
      "Taman Greenwood",
      "Semenyih",
      "Banting",
      "Balakong",
      "Gombak Setia",
      "Kuala Selangor",
      "Serendah",
      "Bukit Beruntung",
      "Pengkalan Kundang",
      "Jenjarom",
      "Sungai Besar",
      "Batu Arang",
      "Tanjung Sepat",
      "Kuang",
      "Kuala Kubu Baharu",
      "Batang Berjuntai",
      "Bandar Baru Salak Tinggi",
      "Sekinchan",
      "Sabak",
      "Tanjung Karang",
      "Beranang",
      "Sungai Pelek",
      "Cyberjaya",
      "Batang Kali",
      "Serdang",
      "Seri Kembangan",
      "Puchong",
      "Sepang",
      "Sg Buloh",
      "Dengkil",
      "Telok Panglima Garang",
      "Bangi",
      "Hulu Langat",
      "Puncak Alam",
      "Setia Alam",
      "Ara Damansara"
    ],
    "Terengganu": [
      "Kuala Terengganu",
      "Chukai",
      "Dungun",
      "Kerteh",
      "Kuala Berang",
      "Marang",
      "Paka",
      "Jerteh"
    ],
    "Kuala Lumpur": [
      "Ampang",
      "Batu Caves",
      "Cheras",
      "Damansara",
      "Gombak",
      "Hulu Kelang",
      "Kepong",
      "Kuala Lumpur",
      "Petaling",
      "Petaling Jaya",
      "Sentul",
      "Setapak",
      "Sungai Besi",
      "Mont Kiara",
      "Bangsar",
      "Bukit Jalil",
      "TTDI",
      "Wangsa Maju",
      "Taman Melawati",
      "Taman Bukit Desa",
      "Old Klang Road",
      "Sri Petaling",
      "Seputeh",
      "Desa Petaling",
      "Pudu",
      "Hartamas",
      "Jinjang",
      "Taman Sri Sinar",
      "Taman Salak Selatan",
      "Taman OUG",
    ],
    "Putrajaya":[
      "Putrajaya",
    ],
    "Labuan":[
      "Batu Arang",
      "Batu Manickar",
      "Bebuloh",
      "Belukut",
      "Bukit Kalam",
      "Bukit Kuda",
      "Durian Tunjung",
      "Ganggarak / Merinding",
      "Gersik / Saguking / Jawa / Parit",
      "Kilan / Kilan Pulau Akar",
      "Lajau",
      "Layang - Layangan",
      "Lubok Temiang",
      "Nagalang / Kerupang",
      "Pantai",
      "Patau - Patau 1",
      "Patau - Patau 2",
      "Pohon Batu",
      "Rancha - Rancha",
      "Sungai Beduan",
      "Sungai Bangkat",
      "Sungai Buton",
      "Sungai Keling",
      "Sungai Lada",
      "Sungai Labu",
      "Sungai Miri / Pagar",
      "Tangung Aru"
    ]
  }

  constructor() { }
}
